import { FormikProps } from 'formik';
import { useEffect, useRef } from 'react';

type ManualForm = {
  name: string;
  onSubmit?: () => Promise<any>;
  onValidate?: () => boolean | Record<string, any>;
};

/**
 * Register event 'validate' listener for form
 */
export default function useFormikRefHook(args?: string | ManualForm, namespace = 'user-wizard') {
  const ref = useRef<FormikProps<Record<string, any>> | null>(null);

  async function handleValidateHook(event: Event) {
    if (!args) return;

    const customEvent = event as CustomEvent;
    const { detail } = customEvent;
    if (!detail) return;

    if (
      detail.namespace === namespace &&
      // Check same name/index
      (typeof args === 'string' ? detail.name === args : detail.name === args.name)
    ) {
      if (typeof args === 'string') {
        // Validate with formik
        const error = await ref.current?.validateForm();

        if (!error || !Object.keys(error).length) {
          customEvent.detail.submit = ref.current?.submitForm as () => Promise<any>;
          detail.done?.();
        }
        return;
      }

      if (!args.onValidate) {
        // No validate fn provided, just next
        detail.done?.();
        return;
      }

      // Manual validate
      const error = await args.onValidate();

      if (!error || !Object.keys(error).length) {
        customEvent.detail.submit = ref.current?.submitForm as () => Promise<any>;
        detail.done?.();
      }
    }
  }

  useEffect(() => {
    window.addEventListener('validate', handleValidateHook);

    return () => {
      window.removeEventListener('validate', handleValidateHook);
    };
  }, []);

  return ref;
}
